const initRegionsAndRoles = () => {
  const module = document.querySelector('.region-and-role');

  if (!module) {
    return;
  }

  const regionButtons = module.querySelectorAll('.region-and-role__region');
  const areaContainers = module.querySelectorAll('.region-and-role__container-roles-category');
  const continueButton = module.querySelector('.region-and-role__continue-button');
  const viewAllLink = module.querySelector('.region-and-role__view-all-link');
  const allPlansButton = document.querySelector('.all-learning-plans-modal__activate');
  const selectionContainer = module.querySelector('.region-and-role__selection-container');
  const selectionContainerValue = module.querySelector('.region-and-role__selection-container .value');
  const selectionDisclaimer = module.querySelector('.region-and-role__button-disclaimer');

  let selectedRegion = null;
  let selectedArea = null;
  let selectedRole = null;

  const STORAGE_KEY = 'selectedRegionKey';

  const isRegionSelectionPath = (path) => {
    return (
      path === '/region-selection/' ||
      path === '/region-selection' ||
      path === '/pt-br/region-selection/' ||
      path === '/pt-br/region-selection' ||
      path === '/zh-hans/region-selection/' ||
      path === '/zh-hans/region-selection' ||
      path === '/region-selection-india/' ||
      path === '/region-selection-india'
    );
  };

  const getReferrerPath = () => {
    if (!document.referrer) {
      return '';
    }

    try {
      const referrerUrl = new URL(document.referrer);

      if (referrerUrl.origin !== window.location.origin) {
        return '';
      }

      return referrerUrl.pathname;
    } catch (error) {
      return '';
    }
  };

  const getCookie = (name) => {
    const escapedName = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const getRegionUrl = (regionKey) => {
    const regionPathMap = {
      na: '/region-selection/',
      br: '/pt-br/region-selection/',
      cn: '/zh-hans/region-selection/',
      in: '/region-selection-india/',
    };

    return `${window.location.origin}${regionPathMap[regionKey] || '/region-selection/'}`;
  };

  const getRegionKeyFromLanguageCookie = () => {
    const path = window.location.pathname;
    const language = getCookie('mc_selected_language_v2');

    const isIndiaPage =
      path === '/region-selection-india/' ||
      path === '/region-selection-india';

    if (isIndiaPage && language === 'en') {
      return 'in';
    }

    if (language === 'pt-br') {
      return 'br';
    }

    if (language === 'zh-hans') {
      return 'cn';
    }

    if (language === 'en') {
      return 'na';
    }

    return null;
  };

  const activateRegionUI = (button) => {
    const regionId = button.getAttribute('data-id');
    const targetAreaContainer = module.querySelector(`#step-2-${regionId}`);

    regionButtons.forEach((btn) => {
      btn.classList.remove('active');
    });

    areaContainers.forEach((container) => {
      container.classList.remove('active');
    });

    button.classList.add('active');
    selectedRegion = button;

    resetAfterRegionChange();

    if (targetAreaContainer) {
      targetAreaContainer.classList.add('active');
    }

    updateContinueButton();
  };

  const resetContinueButton = () => {
    if (!continueButton) {
      return;
    }

    continueButton.classList.add('disabled');
    continueButton.removeAttribute('href');

    if (viewAllLink) {
      viewAllLink.classList.add('disabled');
      viewAllLink.removeAttribute('href');
      allPlansButton.removeAttribute('href');
    }
  };

  const resetSelectionMessage = () => {
    if (selectionContainerValue) {
      selectionContainerValue.innerHTML = '';
      selectionContainer.style.display = 'none';
    }

    if (selectionDisclaimer) {
      selectionDisclaimer.classList.remove('uk-hidden');
    }
  };

  const updateContinueButton = () => {
    if (!continueButton) {
      return;
    }

    if (selectedRegion && selectedArea && selectedRole) {
      const roleHref = selectedRole.getAttribute('data-href') || '';

      if (roleHref && roleHref !== '#') {
        continueButton.setAttribute('href', roleHref);
        continueButton.classList.remove('disabled');
      } else {
        continueButton.removeAttribute('href');
        continueButton.classList.add('disabled');
      }

      if (selectionContainerValue) {
        selectionContainerValue.innerHTML = `${selectedRegion.textContent.trim()} > ${selectedArea.textContent.trim()} > ${selectedRole.textContent.trim()}`;
        selectionContainer.style.display = 'flex';
      }

      if (selectionDisclaimer) {
        selectionDisclaimer.classList.add('uk-hidden');
      }
    } else {
      resetContinueButton();
      resetSelectionMessage();
    }
  };

  const clearActiveRoles = () => {
    module.querySelectorAll('.role.active').forEach((role) => {
      role.classList.remove('active');
    });
  };

  const clearActiveRoleLists = () => {
    module.querySelectorAll('.region-and-role__container-roles.active').forEach((list) => {
      list.classList.remove('active');
    });
  };

  const clearActiveAreas = () => {
    module.querySelectorAll('.region-and-role__category.active').forEach((area) => {
      area.classList.remove('active');
    });
  };

  const resetAfterRegionChange = () => {
    selectedArea = null;
    selectedRole = null;

    clearActiveAreas();
    clearActiveRoleLists();
    clearActiveRoles();
    resetContinueButton();
    resetSelectionMessage();
  };

  regionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const regionKey = button.getAttribute('data-region-key');
      const targetUrl = getRegionUrl(regionKey);

      if (regionKey) {
        sessionStorage.setItem(STORAGE_KEY, regionKey);
      }

      const currentUrl = `${window.location.origin}${window.location.pathname}`;

      if (targetUrl !== currentUrl) {
        window.location.href = targetUrl;
        return;
      }

      activateRegionUI(button);

      const regionId = button.getAttribute('data-id');
      const targetAreaContainer = module.querySelector(`#step-2-${regionId}`);

      if (targetAreaContainer) {
        const containerTop = targetAreaContainer.getBoundingClientRect().top + window.pageYOffset - 200;
        window.scrollTo({
          top: containerTop,
          behavior: 'smooth',
        });
      }
    });
  });

  module.addEventListener('click', (event) => {
    const areaButton = event.target.closest('.region-and-role__category');

    if (!areaButton || !module.contains(areaButton)) {
      return;
    }

    const dataID = areaButton.getAttribute('data-id');
    if (dataID === 'all') {
      const regionKey = selectedRegion.getAttribute('data-region-key');
      if (viewAllLink) {
        const viewAllHref = viewAllLink.getAttribute(`data-href-${regionKey}`);

        if (viewAllHref) {
          viewAllLink.setAttribute('href', viewAllHref);
          viewAllLink.classList.remove('disabled');
          allPlansButton.setAttribute('href', viewAllHref);
        }
      }

      document.querySelectorAll('.region-and-role__category.active').forEach((button) => {
        button.classList.remove('active');
      });

      clearActiveRoleLists();
      clearActiveRoles();

      areaButton.classList.add('active');

      return;
    }

    const activeAreaContainer = areaButton.closest('.region-and-role__container-roles-category');

    if (!activeAreaContainer || !activeAreaContainer.classList.contains('active')) {
      return;
    }

    const regionId = areaButton.getAttribute('data-id');
    const areaIndex = Array.from(
      activeAreaContainer.querySelectorAll('.region-and-role__category')
    ).indexOf(areaButton);

    const targetRoleList = module.querySelector(`#step-3-${regionId}-${areaIndex}`);

    activeAreaContainer.querySelectorAll('.region-and-role__category').forEach((btn) => {
      btn.classList.remove('active');
    });

    clearActiveRoleLists();
    clearActiveRoles();

    areaButton.classList.add('active');
    selectedArea = areaButton;
    selectedRole = null;

    if (targetRoleList) {
      targetRoleList.classList.add('active');
    }

    const containerTop = targetRoleList.getBoundingClientRect().top + window.pageYOffset - 200;
    window.scrollTo({
      top: containerTop,
      behavior: 'smooth',
    });

    updateContinueButton();
  });

  module.addEventListener('click', (event) => {
    const roleButton = event.target.closest('.role');

    if (!roleButton || !module.contains(roleButton)) {
      return;
    }

    const activeRoleList = roleButton.closest('.region-and-role__container-roles');

    if (!activeRoleList || !activeRoleList.classList.contains('active')) {
      return;
    }

    activeRoleList.querySelectorAll('.role').forEach((role) => {
      role.classList.remove('active');
    });

    roleButton.classList.add('active');
    selectedRole = roleButton;

    const roleHref = roleButton.getAttribute('data-href') || '';

    if (continueButton) {
      if (roleHref && roleHref !== '#') {
        continueButton.setAttribute('href', roleHref);
        continueButton.classList.remove('disabled');
      } else {
        continueButton.removeAttribute('href');
        continueButton.classList.add('disabled');
      }
    }

    const buttonContainer = document.querySelector('.region-and-role__button-container');

    if (buttonContainer) {
      const containerTop = buttonContainer.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({
        top: containerTop,
        behavior: 'smooth',
      });
    }

    updateContinueButton();
  });

  if (continueButton) {
    continueButton.addEventListener('click', (event) => {
      if (
        continueButton.classList.contains('disabled') ||
        !selectedRegion ||
        !selectedArea ||
        !selectedRole ||
        !continueButton.getAttribute('href')
      ) {
        event.preventDefault();
      }
    });
  }

  resetContinueButton();
  resetSelectionMessage();

  const savedRegionKey = sessionStorage.getItem(STORAGE_KEY);
  const cookieRegionKey = getRegionKeyFromLanguageCookie();
  const referrerPath = getReferrerPath();
  const currentPath = window.location.pathname;

  const cameFromRegionSelectionFlow =
    isRegionSelectionPath(currentPath) && isRegionSelectionPath(referrerPath);

  let initialRegionKey = null;

  // If the user is already moving inside the region-selection flow
  // (for example changing language with WPML), preserve the selected region.
  if (cameFromRegionSelectionFlow && savedRegionKey) {
    initialRegionKey = savedRegionKey;
  } else if (cookieRegionKey) {
    // First entry or arriving from outside the flow:
    // use the language cookie to decide the default region.
    initialRegionKey = cookieRegionKey;
    sessionStorage.setItem(STORAGE_KEY, cookieRegionKey);
  } else if (savedRegionKey) {
    // Fallback if cookie is missing
    initialRegionKey = savedRegionKey;
  }

  if (initialRegionKey) {
    const matchingRegionButton = module.querySelector(
      `.region-and-role__region[data-region-key="${initialRegionKey}"]`
    );

    if (matchingRegionButton) {
      activateRegionUI(matchingRegionButton);
    }
  }
};

export default initRegionsAndRoles;